"use client";
import { Box, Modal as MantineModal } from "@mantine/core";
import { Modal } from "@/components/Modal";
import ButtonsGroup from "@/components/ButtonsGroup";
import modalClasses from "@/components/Modal/index.module.css";
import { useRouter } from "next/navigation";
import { useTranslation } from "@/i18n/client";
import { Text } from "@mantine/core";
import ContactLink from "@/components/ContactLink";

export default function NotFound() {
  const { t } = useTranslation("modals");
  const router = useRouter();

  const description = (
    <Text variant="reading_medium" mb="1.5rem" style={{ whiteSpace: "pre-wrap" }}>
      <ContactLink href={["tel:8007733022", "mailto:info@eon.cz"]} i18nKey="modals:notFound.description" />
    </Text>
  );
  return (
    <MantineModal opened centered size="md" withCloseButton={false} onClose={() => {}} classNames={modalClasses}>
      <Box pos="relative">
        <Modal.Title>{t("notFound.title")}</Modal.Title>
        <Modal.Description description={description} />
        <ButtonsGroup
          rightButtonText={t("notFound.closeLabel")}
          onRightButtonClick={() => router.push("https://www.eon.cz/")}
          withLeftButton={false}
        />
      </Box>
    </MantineModal>
  );
}
